import { IModifier } from './Modifier';
import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { EAnimationModifiers } from '../../Animation/SpineWrapperEventManager';
import { getAllEventModifiers } from '../../Utils/ModifierUtils';

export class SymbolCountModifier implements IModifier {
    constructor(readonly gameStore: GameStore) {}

    public modifierCheck(name: string): boolean {
        return !!SymbolCountModifier.getSymbolIdAndCount(getAllEventModifiers(name));
    }

    public requirementCheck(name: string): boolean {
        const visibleSymbols = this.gameStore.get(EGameStoreKeys.VisibleSymbols);
        const nameModifiers = getAllEventModifiers(name);
        const symbolIdAndCount = SymbolCountModifier.getSymbolIdAndCount(nameModifiers);
        if (!symbolIdAndCount) return false;
        const [symbolId, symbolCount] = symbolIdAndCount;
        const visibleSymbolCount = visibleSymbols.flat().filter((symbol) => symbol.symbolId === symbolId).length;
        const canPlay = symbolCount === visibleSymbolCount;
        return canPlay;
    }

    public static getSymbolIdAndCount(nameParams: string[]): number[] | undefined {
        const regex = this.patternToRegex(EAnimationModifiers.SYMBOL_COUNT_MODIFIER);
        const modifier = nameParams.find((param) => param.match(regex));
        if (!modifier) return;
        const numbers = modifier.match(regex)?.slice(1).map(Number);
        return numbers;
    }

    public static patternToRegex(pattern: string): RegExp {
        const escaped = pattern
            .split('$')
            .map((part) => part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
            .join('(\\d+)');

        return new RegExp(escaped);
    }
}
